import { STORAGE, API_ENDPOINT } from "../../constants";
import { HTTP } from "../http";
import { StorageService } from "../storage";

export const RegistersService = {
  saveStep1: (data: any) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.post<any, any>(`${API_ENDPOINT}operation/registers/step-1`, {
      ...data,
      account,
    });
  },
  saveStep2: (data: any) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.post<any, any>(`${API_ENDPOINT}operation/registers/step-2`, {
      ...data,
      account,
    });
  },
  list: () => {
    const { account } = StorageService.get(STORAGE.USER);
    const { _id } = StorageService.get(STORAGE.PERIOD);
    return HTTP.get<any, any>(`${API_ENDPOINT}operation/registers/${account}/${_id}`);
  },
  getOne: (_id: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT}operation/registers/one/${_id}`);
  },
  receipt: (form: FormData) => {
    return HTTP.post<any, any>(`${API_ENDPOINT}operation/registers/receipt`, form);
  },
  getFileReceipt: (name: string) => {
    return HTTP.post<any, any>(`${API_ENDPOINT}operation/registers/receipt/file`, { name });
  },
};
